<template>
  <div class="activity">
    <div class="activity-top">
      <DActivityAvatar :activity="activity" />

      <div class="activity-title">
        <DActivityAuthor :activity="activity" />

        <span>
          left a comment on
          <a
            class="resource-link"
            :href="activity.source.url"
            :title="activity.source.title"
            @click.stop
          >
            {{ activity.source.title }}
          </a>
        </span>

        <DActivityTimestamp
          :activity="activity"
          class="visible-until-sm"
        />
      </div>

      <DActivityTimestamp
        :activity="activity"
        class="hidden-until-md"
      />
    </div>

    <div class="comment-box">
      <DTextWithLinks
        :content="activity.parent.body"
        :display-multiline="true"
        :mentions="activity.parent.mentions"
      />
    </div>
  </div>
</template>

<script>
import activityMixin from '../shared/activity-mixin';
import DTextWithLinks from '@d-components/d-text-with-links/d-text-with-links.vue';

export default {
  components: {
    DTextWithLinks,
  },
  mixins: [
    activityMixin,
  ],
};
</script>
